import { render, staticRenderFns } from "./multipleDocumentIcon.vue?vue&type=template&id=7b61763a&scoped=true"
import script from "./multipleDocumentIcon.vue?vue&type=script&lang=js"
export * from "./multipleDocumentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61763a",
  null
  
)

export default component.exports